import VerticalLayout from './layouts/VerticalLayout';

export interface VendorBranchOption {
  id: string;
  branchName: string;
  vendorName: string;
  vendorId: string;
}

interface BranchSelectorProps {
  vendorBranches: VendorBranchOption[];
  selectedVendorBranch?: VendorBranchOption;
  onVendorBranchSelected: (branch: VendorBranchOption) => void;
  className?: string;
}

const getVendors = (
  branches: VendorBranchOption[],
): { name: string; id: string; branches: VendorBranchOption[] }[] => {
  const branchesByVendorMap = branches.reduce((branchesByVendor, branch) => {
    if (branchesByVendor[branch.vendorId]) {
      branchesByVendor[branch.vendorId].branches =
        branchesByVendor[branch.vendorId].branches.concat(branch);
    } else {
      branchesByVendor[branch.vendorId] = {
        name: branch.vendorName,
        id: branch.vendorId,
        branches: [branch],
      };
    }
    return branchesByVendor;
  }, {} as { [vendorId: string]: { name: string; id: string; branches: VendorBranchOption[] } });
  return Object.entries(branchesByVendorMap).map(([_, vendor]) => vendor);
};

const BranchSelector = ({
  vendorBranches,
  selectedVendorBranch,
  onVendorBranchSelected,
  className,
}: BranchSelectorProps) => {
  const vendors = getVendors(vendorBranches);

  const isSelectedBranch = (branchId: string) => {
    return selectedVendorBranch?.id === branchId;
  };

  return (
    <VerticalLayout className={className}>
      {vendors.map((vendor) => {
        return (
          <VerticalLayout key={vendor.id}>
            {vendor.branches.map((branch) => {
              return (
                <div
                  key={branch.id}
                  className={`pl-7 pv-3 cursor-pointer ${
                    isSelectedBranch(branch.id) ? 'bg-blue1 b' : ''
                  }`}
                  onClick={() => onVendorBranchSelected(branch)}
                >
                  {branch.branchName}
                </div>
              );
            })}
          </VerticalLayout>
        );
      })}
    </VerticalLayout>
  );
};

export default BranchSelector;
